import { render, staticRenderFns } from "./TestLayoutView.vue?vue&type=template&id=06be49d7"
import script from "./TestLayoutView.vue?vue&type=script&lang=ts"
export * from "./TestLayoutView.vue?vue&type=script&lang=ts"
import style0 from "./TestLayoutView.vue?vue&type=style&index=0&id=06be49d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports